import ScreenBarPartner from "./components/screen-bar-partner";
import Fireworks from "@fireworks-js/react";
import ScreenDonSection from "./components/screen-don-section";
import {useEffect} from "react";


export default function CustomSaclay({context,loading, campagneData})
{

    const screenOptions=campagneData?.screenOptions || {}

    useEffect(() => {
        document.body.style.margin="0";
        document.body.style.padding="0";
        document.body.style.overflow="hidden";
        document.body.style.cursor="none";
    }, []);


    const StyleBlock=()=>(
        <style jsx global>{`
            @font-face {
                font-family: 'Gravesend-Titre';
                src: url('/campagne/screen/custom-saclay/gravesend-sans-inline.ttf') format('truetype');
                font-display: block;
            }
            @font-face {
                font-family: 'Gravesend-Bold';
                src: url('/campagne/screen/custom-saclay/gravesend-sans-bold.ttf') format('truetype');
                font-display: block;
            }
            @font-face {
                font-family: 'Gravesend-Medium';
                src: url('/campagne/screen/custom-saclay/gravesend-sans-medium.ttf') format('truetype');
                font-display: block;
            }
            @font-face {
                font-family: 'Gravesend-Light';
                src: url('/campagne/screen/custom-saclay/gravesend-sans-light.ttf') format('truetype');
                font-display: block;
            }

            @keyframes csaclayFadeIn {
                from { opacity: 0; transform: translateY(2vh) scale(0.96); }
                to   { opacity: 1; transform: translateY(0)   scale(1); }
            }

            .csaclay-don-card {
                background: url('/campagne/screen/custom-saclay/carrésaclay.png') center/100% 100% no-repeat;
                width: 21vw;
                aspect-ratio: 16 / 9;
                box-sizing: border-box;
                animation-duration: 1.2s;
                animation-fill-mode: both;
                position: relative;
            }
            .csaclay-don-name {
                position: absolute;
                left: 8%;
                right: 8%;
                top: 28%;
                text-align: center;
                color: #162c4a;
                font-family: 'Gravesend-Bold', sans-serif;
                font-size: 2vh;
                line-height: 1.1;
                letter-spacing: 0.02em;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            .csaclay-don-amount {
                position: absolute;
                left: 16%;
                right: 16%;
                top: 50%;
                height: 22%;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #dcc3b6;
                font-family: 'Gravesend-Bold', sans-serif;
                font-size: 1.8vh;
                letter-spacing: 0.04em;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            .csaclay-fade-in  { animation-name: csaclayFadeIn; }
            .csaclay-fade-out { display: none; }
        `}</style>
    )


    if(loading)
    {
        return (
            <div style={{aspectRatio: "16/9", position: "relative", width:"100vw", height:"100vh", overflow:"hidden"}}>
                <StyleBlock/>
                <div className={"screen-background"}/>
            </div>
        )
    }


    return (
        <div style={{aspectRatio: "16/9", position: "relative", width:"100vw", height:"100vh", overflow:"hidden"}}>
            <StyleBlock/>

            <div className={"screen-background"} style={{position:"absolute", inset:0}}>
                <img src={"/campagne/screen/custom-saclay/screensaclay.png"}
                     alt=""
                     style={{width:"100%", height:"100%", objectFit:"cover", display:"block"}}/>
            </div>

            <div className={"screen-content"} style={{position:"absolute", inset:0}}>
                <div style={{
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    paddingTop: "16vh",
                    boxSizing: "border-box",
                }}>

                    <ScreenBarPartner context={context} campagneData={campagneData} mini={screenOptions.barMini}/>

                    <div style={{marginTop:"auto", width:"100%", paddingBottom:"6vh"}}>
                        <ScreenDonSection context={context} campagneData={campagneData}/>
                    </div>


                    {screenOptions.forceCelebration && (
                        <Fireworks
                            autostart
                            options={{intensity:30, particles:100, traceLength:1, opacity:0.2}}
                            style={{
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                position: 'fixed',
                                background: 'transparent'
                            }}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}
